/**
 * @description 公共的一些路由，不属于功能模块的都放这里统一管理
 * @author fhtwl */

import router403 from './403';
import router404 from './404';
import auth from './auth';

export default [...auth, ...router404, ...router403];
